"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var semver = require('semver');
var CATEGORIES = {
  'integration': 'Integration',
  'networking': 'Networking',
  'live': 'Live',
  'learning': 'Learning',
  'content and logistics': 'Content and logistics'
};
var IMAGE_KEYS = ['icon', 'image_1', 'image_2', 'image_3', 'image_4'];
var STAGE_BETA = 'beta';
var getModuleDetailsFields = function getModuleDetailsFields() {
  return {
    name: {
      order: 1,
      kind: 'choice-list',
      label: 'Module',
      kind_options: {
        list_style: 'select',
        values: {}
      },
      validations: {
        required: true
      },
      category: 'Module details'
    },
    title: {
      order: 2,
      kind: 'text',
      label: 'Title',
      validations: {
        required: true
      },
      category: 'Module details'
    },
    tagline: {
      order: 3,
      kind: 'text',
      label: 'Tagline',
      validations: {
        max: 80,
        required: true
      },
      category: 'Module details'
    },
    categories: {
      order: 4,
      kind: 'list',
      label: 'Categories',
      kind_options: {
        item_kind: 'choice-list',
        values: CATEGORIES
      },
      category: 'Module details'
    },
    icon: {
      order: 5,
      kind: 'file',
      label: 'icon',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Module details'
    },
    private: {
      order: 6,
      kind: 'choice',
      label: 'Visibility',
      kind_options: {
        list_style: 'select',
        values: {
          public: 'Public',
          private: 'Private'
        }
      },
      validations: {
        required: true
      },
      default: 'public',
      category: 'Module details'
    },
    paid: {
      order: 7,
      kind: 'boolean',
      label: 'Paid',
      category: 'Module details'
    },
    beta: {
      order: 8,
      kind: 'boolean',
      label: 'Beta',
      category: 'Module details'
    },
    stage_url: {
      order: 9,
      kind: 'url',
      label: 'Beta contact url',
      category: 'Module details'
    },
    version: {
      order: 1,
      kind: 'choice',
      label: 'Version',
      kind_options: {
        list_style: 'select',
        values: {}
      },
      category: 'Version documentation'
    },
    state: {
      order: 2,
      kind: 'choice',
      label: 'Status',
      kind_options: {
        list_style: 'select',
        values: {
          draft: 'Draft',
          published: 'Published'
        }
      },
      validations: {
        required: true
      },
      category: 'Version documentation',
      default: 'draft'
    },
    image_1: {
      order: 3,
      kind: 'file',
      label: 'Image 1',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    image_2: {
      order: 4,
      kind: 'file',
      label: 'Image 2',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    image_3: {
      order: 5,
      kind: 'file',
      label: 'Image 3',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    image_4: {
      order: 6,
      kind: 'file',
      label: 'Image 4',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    changelog: {
      order: 7,
      kind: 'html',
      label: 'What\'s new?',
      tooltip: 'Tell users what has changed with the new version of this module',
      kind_options: {
        rows: 10
      },
      validations: {
        required: true
      },
      category: 'Version documentation'
    },
    description: {
      order: 8,
      kind: 'html',
      label: 'Description',
      tooltip: 'This field supports Markdown and HTML',
      kind_options: {
        rows: 10
      },
      validations: {
        required: true
      },
      category: 'Version documentation'
    },
    description_url: {
      order: 9,
      kind: 'url',
      label: 'Documentation URL',
      tooltip: 'Paste here the link to the documentation for this module',
      category: 'Version documentation'
    }
  };
};

/**
 * Prepares data for the listing of packages
 *
 * @param {array} pkgs
 * @param {array} versions
 * @returns {array}
 */
var getPackageList = function getPackageList(pkgs, versions) {
  return pkgs.map(function (pkg) {
    var latestVersion = versions[pkg.name].latest;
    var hasLatestDraft = pkg.latestDraft === latestVersion;
    var hasNewVersion = !hasLatestDraft && pkg.latestPublished !== latestVersion;
    var latestDescVersion = semver.gt(pkg.latestPublished || '0.0.0', pkg.latestDraft || '0.0.0') ? pkg.latestPublished : pkg.latestDraft;
    return Object.assign(pkg, {
      latestVersion: latestVersion,
      hasLatestDraft: hasLatestDraft,
      hasNewVersion: hasNewVersion,
      latestDescVersion: latestDescVersion
    });
  });
};

/**
 * Prepares values for package dropdown
 *
 * @param {array} pkgs
 * @param {array} versions
 * @returns {object}
 */
var getPkgNameOptions = function getPkgNameOptions(pkgs, versions) {
  var names = Object.keys(versions);
  var namesWithDesc = _.chain(pkgs).pluck('name').unique().value();
  var namesWithoutDesc = _.difference(names, namesWithDesc);
  return _.object(namesWithoutDesc, _.map(namesWithoutDesc, function (name) {
    return "pkg-".concat(name);
  }));
};

/**
 * Prepares values for version dropdown
 *
 * @param {array} versions
 * @returns {object}
 */
var getVersionOptions = function getVersionOptions(versions) {
  var result = {};
  for (var _i = 0, _Object$keys = Object.keys(versions); _i < _Object$keys.length; _i++) {
    var pkgName = _Object$keys[_i];
    result[pkgName] = _.object(versions[pkgName].versions, versions[pkgName].versions);
  }
  return result;
};

/**
 * Checks changes in name and version dropdowns
 * When name changes, it loads correct values in the
 * version dropdown.
 * When version changes, it loads description for given/latest matching
 * version and sets the model values (only in edit mode).
 *
 * @param {OrgPackageManager} ctrl
 */
var prepareModalData = function prepareModalData(ctrl) {
  var pkgName = ctrl.model.name;
  if (pkgName !== ctrl.prevPkgName) {
    if (pkgName) {
      ctrl.moduleDetailsFields.version.kind_options.values = ctrl.versionOptions[pkgName];
      if (!ctrl.isEditModal) {
        ctrl.model.version = ctrl.versions[pkgName].latest;
      }
    } else {
      ctrl.moduleDetailsFields.version.kind_options.values = {};
      delete ctrl.model.version;
    }
    ctrl.prevPkgName = pkgName;
  }
  var version = ctrl.model.version;
  if (ctrl.isEditModal && version && version !== ctrl.prevVersion) {
    ctrl.prevVersion = version;
    return updateModelWithDesc(ctrl, pkgName, version);
  }
};

/**
 * Tries to get package description for given version from the API.
 * The API returns either description object or the 404 error code with
 * the latest available description.
 *
 * @param {OrgPackageManager} ctrl
 * @param {string} pkgName
 * @param {string} version
 */
var updateModelWithDesc = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ctrl, pkgName, version) {
    var _i2, _Object$keys2, key, desc, latestMatchingVersion;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // dont use _.pick here as it makes copy of object and the modal flashes
          for (_i2 = 0, _Object$keys2 = Object.keys(ctrl.model); _i2 < _Object$keys2.length; _i2++) {
            key = _Object$keys2[_i2];
            if (key !== 'name' && key !== 'version') {
              delete ctrl.model[key];
            }
          }
          desc = null;
          _context.prev = 2;
          _context.next = 5;
          return ctrl.packageManagerService.getPackageDescription(ctrl.orgId, pkgName, version);
        case 5:
          desc = _context.sent;
          _context.next = 18;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](2);
          if (!(_context.t0.response.status === 404 && _context.t0.response.data.latest_matching_description)) {
            _context.next = 17;
            break;
          }
          latestMatchingVersion = _context.t0.response.data.latest_matching_description;
          _context.next = 14;
          return ctrl.packageManagerService.getPackageDescription(ctrl.orgId, pkgName, latestMatchingVersion);
        case 14:
          desc = _context.sent;
          _context.next = 18;
          break;
        case 17:
          console.log('Latest matching description not found.');
        case 18:
          if (desc) {
            setDescToModel(ctrl, desc);
          }
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 8]]);
  }));
  return function updateModelWithDesc(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Transforms the description object from API to model.
 *
 * @param {OrgPackageManager} ctrl
 * @param {object} desc
 */
var setDescToModel = function setDescToModel(ctrl, desc) {
  var getImagePlaceholder = function getImagePlaceholder(key) {
    return {
      name: key,
      size: 0,
      // to pass validation
      uploaded: true
    };
  };
  desc.private = desc.private ? 'private' : 'public';
  desc.icon = desc.icon ? getImagePlaceholder('icon') : null;
  desc.beta = desc.stage === STAGE_BETA;
  var imageKeys = IMAGE_KEYS.filter(function (key) {
    return key !== 'icon';
  });
  var imageVals = imageKeys.map(function (key, idx) {
    return desc.images[idx] ? getImagePlaceholder(key) : null;
  });
  _.extend(desc, _.object(imageKeys, imageVals));
  ctrl.desc = desc;

  // omit the version property so we don't override the one in the model in
  // case of last matching description
  _.extend(ctrl.model, _.omit(desc, 'version', 'stage'));
};
var OrgPackageManager = /*#__PURE__*/function () {
  OrgPackageManager.$inject = ["$route", "$rootScope", "packageManagerService", "modalService"];
  /* @ngInject */
  function OrgPackageManager($route, $rootScope, packageManagerService, modalService) {
    _classCallCheck(this, OrgPackageManager);
    this.$route = $route;
    this.$rootScope = $rootScope;
    this.packageManagerService = packageManagerService;
    this.modalService = modalService;
    this.filtered = [];
    this.model = {};
  }
  _createClass(OrgPackageManager, [{
    key: "$onInit",
    value: function () {
      var _$onInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var pkgs, versions, _yield$Promise$all, _yield$Promise$all2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = true;
              this.orgId = this.organisation._id;
              _context2.prev = 2;
              _context2.next = 5;
              return Promise.all([this.packageManagerService.getPackageDescriptions(this.orgId), this.packageManagerService.getOrgPackageVersions(this.orgId)]);
            case 5:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              pkgs = _yield$Promise$all2[0];
              versions = _yield$Promise$all2[1];
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](2);
              console.log('Failed to load packages.', _context2.t0);
            case 14:
              this.versions = versions;
              this.packages = getPackageList(pkgs, versions);
              this.pkgNameOptions = getPkgNameOptions(pkgs, versions);
              this.versionOptions = getVersionOptions(versions);
              this.loading = false;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 11]]);
      }));
      function $onInit() {
        return _$onInit.apply(this, arguments);
      }
      return $onInit;
    }()
  }, {
    key: "$doCheck",
    value: function $doCheck() {
      if (!this.isModalOpened) {
        return;
      }
      prepareModalData(this);
    }
  }, {
    key: "hasPkgsWithoutDesc",
    value: function hasPkgsWithoutDesc() {
      return !_.isEmpty(this.pkgNameOptions);
    }
  }, {
    key: "showNewDescriptionModal",
    value: function showNewDescriptionModal() {
      this.isEditModal = false;
      this.isModalOpened = true;
      this.moduleDetailsFields = getModuleDetailsFields();
      this.moduleDetailsFields.name.kind_options.values = this.pkgNameOptions;
      this.descFormModal = this.modalService.openModal({
        templateUrl: '/src/angular/components/orgs/view-org/org-package-manager/org-package-description-modal.html',
        scope: {
          $ctrl: this
        },
        cssClasses: 'org-package-manager-modal'
      });
    }
  }, {
    key: "showEditDescriptionModal",
    value: function () {
      var _showEditDescriptionModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(pkgRow) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.isEditModal = true;
              this.model.name = pkgRow.name;
              this.model.version = pkgRow.latestDescVersion;
              this.moduleDetailsFields = getModuleDetailsFields();
              this.moduleDetailsFields.name.kind_options.values = _defineProperty({}, pkgRow.name, "pkg-".concat(pkgRow.name));
              if (pkgRow.hasLatestDraft) {
                this.moduleDetailsFields.version.label_html = '<span class=\'badge badge-draft\'>Draft</span>';
              }
              if (pkgRow.hasNewVersion) {
                this.moduleDetailsFields.version.label_html = '<span class=\'badge badge-new-version\'>New version!</span>';
              }
              _context3.next = 9;
              return prepareModalData(this);
            case 9:
              this.isModalOpened = true;
              this.descFormModal = this.modalService.openModal({
                templateUrl: '/src/angular/components/orgs/view-org/org-package-manager/org-package-description-modal.html',
                scope: {
                  $ctrl: this
                },
                cssClasses: 'org-package-manager-modal'
              });
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function showEditDescriptionModal(_x4) {
        return _showEditDescriptionModal.apply(this, arguments);
      }
      return showEditDescriptionModal;
    }()
  }, {
    key: "closeDescriptionModal",
    value: function closeDescriptionModal() {
      this.descFormModal.close();
      this.model = {};
      this.prevPkgName = null;
      this.prevVersion = null;
      this.isModalOpened = false;
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$model, packageName, version, images, result, imagesToDelete, _i3, _Object$keys3, imageId, _i4, _imagesToDelete, _imageId;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this$model = this.model, packageName = _this$model.name, version = _this$model.version;
              this.saving = true;
              this.model.private = this.model.private === 'private' ? true : false;

              // normalize description and changelog until BST-95 is fixed
              this.model.changelog = this.model.changelog || ' ';
              this.model.description = this.model.description || ' ';
              if (!(this.model.beta && !this.model.stage_url)) {
                _context4.next = 8;
                break;
              }
              this.saving = false;
              return _context4.abrupt("return", this.$rootScope.setFlashMessage('Beta contact Url is a required field for beta modules', 'warning'));
            case 8:
              this.model.stage = this.model.beta ? STAGE_BETA : null;
              this.model.stage_url = this.model.beta ? this.model.stage_url : null;
              images = _.pick(this.model, IMAGE_KEYS);
              images = _.omit(images, function (image) {
                return (image || {}).uploaded;
              });
              _context4.prev = 12;
              result = true;
              imagesToDelete = [];
              _i3 = 0, _Object$keys3 = Object.keys(images);
            case 16:
              if (!(_i3 < _Object$keys3.length)) {
                _context4.next = 29;
                break;
              }
              imageId = _Object$keys3[_i3];
              if (!images[imageId]) {
                _context4.next = 25;
                break;
              }
              _context4.t0 = result;
              _context4.next = 22;
              return this.packageManagerService.savePackageImage(this.orgId, packageName, version, imageId, images[imageId]);
            case 22:
              result = _context4.t0 &= _context4.sent;
              _context4.next = 26;
              break;
            case 25:
              if (this.desc[imageId]) {
                imagesToDelete.push(imageId);
              }
            case 26:
              _i3++;
              _context4.next = 16;
              break;
            case 29:
              _context4.next = 31;
              return this.packageManagerService.savePackageDescription(this.orgId, packageName, version, this.model);
            case 31:
              result = _context4.sent;
              _i4 = 0, _imagesToDelete = imagesToDelete;
            case 33:
              if (!(_i4 < _imagesToDelete.length)) {
                _context4.next = 42;
                break;
              }
              _imageId = _imagesToDelete[_i4];
              _context4.t1 = result;
              _context4.next = 38;
              return this.packageManagerService.deletePackageImage(this.orgId, packageName, version, _imageId);
            case 38:
              result = _context4.t1 &= _context4.sent;
            case 39:
              _i4++;
              _context4.next = 33;
              break;
            case 42:
              if (result) {
                _context4.next = 44;
                break;
              }
              throw new Error('Failed to save package description.');
            case 44:
              _context4.next = 51;
              break;
            case 46:
              _context4.prev = 46;
              _context4.t2 = _context4["catch"](12);
              console.log(_context4.t2);
              this.saving = false;
              return _context4.abrupt("return", this.$rootScope.setFlashMessage('Failed to save package description.', 'danger'));
            case 51:
              this.closeDescriptionModal();
              this.saving = false;
              this.$rootScope.setFlashMessage('Package description saved successfully.');
              return _context4.abrupt("return", this.$route.reload());
            case 55:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[12, 46]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }]);
  return OrgPackageManager;
}();
module.exports = angular.module('backstage.components.orgs.view-org.package-manager', ['backstage.services']).component('bsOrgPackageManager', {
  templateUrl: '/src/angular/components/orgs/view-org/org-package-manager/org-package-manager.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgPackageManager
}).name;